export interface User {
    id: number
    name: string
}

export const defaultUser: User = {
    id: 0
    , name: ''
}